<template>
  <v-container>
    <v-card
      outlined
      class="pa-3 mb-3"
    >
      <v-row dense>
        <v-col
          cols="12"
          md="6"
        >
          <v-text-field
            v-model="filter"
            outlined
            dense
            hide-details
            clearable
            prepend-inner-icon="mdi-magnify"
            label="ຄົ້ນຫາ: ຊື່ບໍລິສັດ, ເບີໂທ, COM_, ເລກບິນ (ID#)"
            @keyup.enter="load(1)"
            @click:clear="clearFilter"
          />
        </v-col>
        <v-col
          cols="6"
          md="3"
        >
          <v-text-field
            v-model="month"
            type="month"
            outlined
            dense
            hide-details
            clearable
            label="ເດືອນບິນ"
            @change="load(1)"
          />
        </v-col>
        <v-col
          cols="6"
          md="3"
          class="d-flex align-center"
        >
          <v-btn
            color="primary"
            depressed
            @click="load(1)"
          >
            <v-icon left>
              mdi-magnify
            </v-icon>
            ຄົ້ນຫາ
          </v-btn>
        </v-col>
      </v-row>
      <div class="text-caption grey--text mt-2">
        ສະແດງສະເພາະບິນລູກຄ້າທຸລະກິດ. ບິນທີ່ຊຳລະແລ້ວ ສະແດງໃຫ້ເຫັນ ແຕ່ເລືອກລຶບບໍ່ໄດ້.
      </div>
    </v-card>

    <v-card
      v-if="selected.length"
      outlined
      class="pa-3 mb-3"
    >
      <div class="mb-2 font-weight-medium">
        ບິນທີ່ເລືອກ {{ selected.length }} ໃບ · ລວມ {{ money(selectedTotal) }} ກີບ
      </div>
      <v-chip
        v-for="bill in selected"
        :key="bill.id"
        small
        close
        class="mr-1 mb-1"
        @click:close="unselect(bill)"
      >
        {{ bill.bill_number }} · {{ bill.company_name }} · {{ money(bill.total) }}
      </v-chip>
      <v-textarea
        v-model="reason"
        outlined
        dense
        rows="2"
        auto-grow
        class="mt-2"
        label="ເຫດຜົນທີ່ຂໍລຶບ *"
        :error-messages="reasonError"
        @input="reasonError = ''"
      />
      <div class="d-flex">
        <v-spacer />
        <v-btn
          color="error"
          depressed
          :loading="sending"
          @click="confirm = true"
        >
          <v-icon left>
            mdi-send
          </v-icon>
          ສົ່ງຂໍລຶບ {{ selected.length }} ໃບ
        </v-btn>
      </div>
    </v-card>

    <v-card outlined>
      <v-data-table
        v-model="selected"
        :headers="headers"
        :items="bills"
        :loading="loading"
        item-key="id"
        show-select
        selectable-key="selectable"
        :item-class="rowClass"
        hide-default-footer
        disable-pagination
        disable-sort
        no-data-text="ບໍ່ພົບບິນ"
      >
        <template v-slot:[`item.company_name`]="{ item }">
          <div>{{ item.company_name }}</div>
          <div class="text-caption grey--text">
            {{ item.customer_code }} · {{ item.phone }}
          </div>
        </template>
        <template v-slot:[`item.total`]="{ item }">
          {{ money(item.total) }}
        </template>
        <template v-slot:[`item.status_la`]="{ item }">
          <v-chip
            x-small
            :color="getBgColor(item.status)"
            dark
          >
            {{ item.status_la }}
          </v-chip>
          <div
            v-if="item.paid"
            class="text-caption red--text"
          >
            ຊຳລະແລ້ວ · ລຶບບໍ່ໄດ້
          </div>
          <div
            v-else-if="item.pending_request_id"
            class="text-caption orange--text text--darken-2"
          >
            ມີຄຳຂໍລຶບ #{{ item.pending_request_id }} ລໍຖ້າຢູ່
          </div>
        </template>
      </v-data-table>
      <v-pagination
        v-if="pagination.total_pages > 1"
        v-model="page"
        :length="pagination.total_pages"
        :total-visible="7"
        class="my-2"
        @input="load"
      />
    </v-card>

    <h3 class="mt-6 mb-2">
      ຄຳຂໍລຶບຂອງຂ້ອຍ (ລໍຖ້າ / ຖືກປະຕິເສດ)
    </h3>
    <v-card outlined>
      <v-data-table
        :headers="mineHeaders"
        :items="mine"
        hide-default-footer
        disable-pagination
        no-data-text="ບໍ່ມີຄຳຂໍທີ່ຄ້າງ"
      >
        <template v-slot:[`item.status`]="{ item }">
          <v-chip
            x-small
            :color="item.status === 'rejected' ? 'red lighten-5' : 'amber lighten-5'"
            :text-color="item.status === 'rejected' ? 'red darken-2' : 'amber darken-4'"
          >
            {{ item.status === 'rejected' ? 'ຖືກປະຕິເສດ' : 'ລໍຖ້າອະນຸມັດ' }}
          </v-chip>
          <div
            v-if="item.reject_reason"
            class="text-caption red--text"
          >
            {{ item.reject_reason }}
          </div>
        </template>
        <template v-slot:[`item.items`]="{ item }">
          <div
            v-for="bill in item.items"
            :key="bill.id"
            class="text-caption"
          >
            {{ bill.bill_number }} · {{ bill.customer_name }} · {{ money(bill.total) }}
          </div>
        </template>
      </v-data-table>
    </v-card>

    <v-dialog
      v-model="confirm"
      max-width="460"
    >
      <v-card>
        <v-card-title>ຢືນຢັນສົ່ງຂໍລຶບບິນ</v-card-title>
        <v-card-text>
          ສົ່ງຄຳຂໍລຶບ {{ selected.length }} ໃບ (ລວມ {{ money(selectedTotal) }} ກີບ) ໄປໃຫ້ຜູ້ອະນຸມັດ?
          ບິນຈະຖືກລຶບ ເມື່ອຄຳຂໍໄດ້ຮັບການອະນຸມັດ.
        </v-card-text>
        <v-card-actions>
          <v-spacer />
          <v-btn
            text
            @click="confirm = false"
          >
            ຍົກເລີກ
          </v-btn>
          <v-btn
            color="error"
            depressed
            :loading="sending"
            @click="send"
          >
            ສົ່ງຂໍລຶບ
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { getBgColor } from '@/Helpers/BillingStatus';

export default {
  name: 'BillDeleteRequest',
  title() {
    return 'Vientiane Waste Co-Dev|Bill Delete Request';
  },
  data() {
    return {
      filter: '',
      month: '',
      bills: [],
      loading: false,
      page: 1,
      pagination: {},
      selected: [],
      reason: '',
      reasonError: '',
      confirm: false,
      sending: false,
      mine: [],
      headers: [
        { text: 'ເລກບິນ', value: 'bill_number' },
        { text: 'ລູກຄ້າ', value: 'company_name' },
        { text: 'ລາຍການ', value: 'content' },
        { text: 'ເດືອນບິນ', value: 'bill_month' },
        { text: 'ຍອດເງິນ', value: 'total', align: 'end' },
        { text: 'ສະຖານະ', value: 'status_la' },
      ],
      mineHeaders: [
        { text: 'ເລກຄຳຂໍ', value: 'id' },
        { text: 'ບິນ', value: 'items', sortable: false },
        { text: 'ເຫດຜົນ', value: 'reason', sortable: false },
        { text: 'ວັນທີສົ່ງ', value: 'created_at' },
        { text: 'ສະຖານະ', value: 'status' },
      ],
    };
  },
  computed: {
    selectedTotal() {
      return this.selected.reduce((sum, bill) => sum + Number(bill.total || 0), 0);
    },
  },
  created() {
    this.load(1);
    this.loadMine();
  },
  methods: {
    getBgColor,
    money(value) {
      return Number(value || 0).toLocaleString();
    },
    rowClass(item) {
      return item.selectable ? '' : 'grey lighten-4';
    },
    unselect(bill) {
      this.selected = this.selected.filter((b) => b.id !== bill.id);
    },
    clearFilter() {
      this.filter = '';
      this.load(1);
    },
    load(page) {
      this.page = page || 1;
      this.loading = true;
      this.$axios
        .get('bill-delete-request/bills', {
          params: {
            page: this.page, per_page: 50, filter: this.filter || undefined, month: this.month || undefined,
          },
        })
        .then((res) => {
          // selectable-key: paid bills and bills already in a pending request can't be ticked (select-all too).
          this.bills = (res.data.data.data || []).map((bill) => ({ ...bill, selectable: !bill.paid && !bill.pending_request_id }));
          this.pagination = res.data.data.pagination || {};
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.loading = false;
        });
    },
    loadMine() {
      this.$axios
        .get('bill-delete-request', { params: { per_page: 50 } })
        .then((res) => {
          this.mine = res.data.data.data || [];
        })
        .catch(() => {});
    },
    send() {
      if (!this.reason || !this.reason.trim()) {
        this.reasonError = 'ກະລຸນາໃສ່ເຫດຜົນ';
        this.confirm = false;
        return;
      }
      this.sending = true;
      this.$axios
        .post('bill-delete-request', { billing_ids: this.selected.map((b) => b.id), reason: this.reason.trim() })
        .then(() => {
          this.toast('success', 'ສົ່ງຄຳຂໍລຶບແລ້ວ, ລໍຖ້າອະນຸມັດ');
          this.selected = [];
          this.reason = '';
          this.load(this.page);
          this.loadMine();
        })
        .catch((error) => this.toast('error', this.message(error)))
        .finally(() => {
          this.sending = false;
          this.confirm = false;
        });
    },
    message(error) {
      return (error.response && error.response.data && error.response.data.message) || 'Something went wrong';
    },
    toast(color, msg) {
      this.$store.commit('Toast_State', { value: true, color, msg });
    },
  },
};
</script>
